import { NotificationMessage } from "components/Toast";
import { makeAutoObservable } from "mobx";
import { localStorageKeys } from "./enums";

interface ElementPos {
  left: number | string | undefined;
  top: number | string | undefined;
}

export interface Tooltip {
  content?: string | React.ReactNode;
  children?: string | React.ReactNode;
  active?: boolean;
  position?: ElementPos;
  direction?: string;
  delay?: number;
  className?: string;
  whiteTheme?: boolean;
  hoverOnTooltip?: boolean;
  disableStickOnHover?: boolean;
  align?: "right";
  icon?: React.ReactElement;
}

interface TableDragging {
  state: boolean;
  startY: number;
  minIndex: number | null;
  maxIndex: number | null;
  isDragging: boolean;
}

export const SIDEBAR_WIDTH = 350;

class GlobalStore {
  tooltip: Tooltip | undefined = undefined;
  tootipWrapperHover = false;
  toastList: NotificationMessage[] = [];
  tableDragging: TableDragging = {
    state: false,
    startY: 0,
    minIndex: null,
    maxIndex: null,
    isDragging: false,
  };
  draggedRows: number[] = [];
  currentLanguage: string = "en";
  sidebarOpened: boolean = true;

  setTooltipContent(tooltip: Tooltip | undefined) {
    this.tooltip = tooltip;
  }

  setTootipWrapperHover(tootipWrapperHover: boolean) {
    this.tootipWrapperHover = tootipWrapperHover;
  }

  setToastList(toastList: NotificationMessage[]) {
    this.toastList = toastList;
  }

  setTableDragging(tableDragging: TableDragging) {
    this.tableDragging = tableDragging;
  }

  setDraggedRows(draggedRows: number[]) {
    this.draggedRows = draggedRows;
  }

  setCurrentLanguage(currentLanguage: string) {
    this.currentLanguage = currentLanguage;
  }

  setSidebarOpened(sidebarOpened: boolean) {
    if (window.innerWidth > 768) {
      localStorage.setItem(
        localStorageKeys.sidebarOpened,
        sidebarOpened !== null ? sidebarOpened.toString() : "false"
      );
    }
    this.sidebarOpened = sidebarOpened;
  }

  constructor() {
    makeAutoObservable(this);
    this.sidebarOpened =
      localStorage.getItem(localStorageKeys.sidebarOpened) === "true"
        ? window.innerWidth > 768
        : false;
  }

  static instance: GlobalStore;

  static getInstance(): GlobalStore {
    if (!GlobalStore.instance) {
      GlobalStore.instance = new GlobalStore();
    }
    return GlobalStore.instance;
  }
}

export const globalStore = GlobalStore.getInstance();
